import { render, staticRenderFns } from "./EnvironmentalAllergiesTemplate.vue?vue&type=template&id=41dc93dd"
import script from "./EnvironmentalAllergiesTemplate.vue?vue&type=script&lang=js"
export * from "./EnvironmentalAllergiesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports